module.exports = __webpack_public_path__ + "static/media/correct.8786c17f.svg";